// Search here. https://remixicon.com/

export const icons = {
    "afs-generate": "ri-refresh-line",
    "afs-main": "ri-bank-line",
    "afs-copy": "ri-clipboard-line",
    "afs-logging": "ri-bug-2-line",
    "afs-policies": "ri-verified-badge-line",
    "afs-import": "ri-import-fill",
    "afs-template-builder": "ri-layout-2-line",
    "afs-specimen": "ri-file-word-2-line",
    "afs-online-mcs": "ri-book-open-line",
    "afs-token": "ri-shield-line",
    "afs-translations": "ri-text-snippet",
    "afs-settings": "ri-settings-4-line",
    "afs-audit": "ri-shield-check-line",
    "afs-dashboard": "ri-dashboard-2-line",
    "afs-statements": "ri-file-chart-2-fill",
    "afs-appropriations": "ri-survey-fill",
    "afs-notes": "ri-sticky-note-line",
    "afs-submit": "ri-send-plane-fill",
    "afs-per": "ri-line-chart-fill",
    "afs-pos": "ri-money-dollar-circle-line",
    "afs-audit-log": "ri-survey-fill",
    "afs-glossary": "ri-book-3-line",
    "afs-assistant": "ri-robot-2-line",
    "afs-trial-balance": "ri-scales-2-line",
    "afs-imported-trial-balance": "ri-file-upload-line",
    "afs-per-imported": "ri-file-chart-line"
}
